import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  selector: 'email-texting-notification-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './texting-notification.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TextingNotificationTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TextingNotificationTemplateData>;
}

export type TextingNotificationTemplateData = {
  title: string;
  p1: string;
  p2: string;
  button_link: string;
  button_text: string;
  footer: string;
  support_email: string;
};

export const TextingNotificationTemplateMocks: TextingNotificationTemplateData[] = [
  {
    title: 'Your company has less than 500 text messages',
    p1: 'Heads up! It looks like your company’s text messaging is going well. Make sure that you have enough within the current limit or wait until the next billing period. Please note that both outgoing and incoming messages are deducted from your pool of messages.',
    p2: 'Want more texts? Contact our support or wait until your limit renews on January 13.',
    button_link: 'https://app.s.recruitee.com/#/settings/texting',
    button_text: 'Go to settings',
    footer: 'Need help?',
    support_email: 'support@recruitee.com',
  },
];
